import useRoutes from 'hooks/useRoutes'
import { useSnackbar } from 'notistack'

/**
 * @function useResErrors
 *  hook
 *  @example const {standardCheck} = useResErrors()
 *  @return {Object}  {standardCheck()}
 */
const useResErrors = () => {
  const { unAuthByStatus } = useRoutes()
  const { enqueueSnackbar } = useSnackbar()
  /**
   * @function standardCheck
   * checkOnError
   * @param {object|array} res
   * @param {function} onSuccess
   * @param {string} textErr
   * @param {boolean} isCustomErr
   * @param {function} onErrCustom
   * @param {function} actionError
   *  @example standardCheck(res,onSuccess(),'Error')
   */
  const standardCheck = (
    res,
    onSuccess,
    textErr = ' ',
    actionError = () => {},
    isCustomErr = false,
    onErrCustom = () => {}
  ) => {
    if (res && !res.hasOwnProperty('err')) {
      try {
        onSuccess()
      } catch (e) {
        console.error(e)
      }
    } else {
      const status = res.hasOwnProperty('status') ? res.status : ''
      unAuthByStatus(status)
      if (!isCustomErr) {
        enqueueSnackbar(res.err + textErr + status, {
          variant: 'error'
        })
        actionError()
      } else {
        onErrCustom(status)
      }
    }
  }
  return {
    standardCheck
  }
}
export default useResErrors
